<div class="bg-white dark:bg-gray-800 shadow-md rounded-lg px-4 py-3 w-full">
  <section
    class="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 pb-3 mb-4"
  >
    <div class="flex items-center">
      <img
        [src]="tabIcon()"
        alt="Integración"
        class="h-8 w-8 mr-3"
      />
      <h2 class="text-lg font-medium text-gray-900 dark:text-white">
        Integración con {{ tabLabel() }}
      </h2>
    </div>
    <button
      (click)="onClose()"
      class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
    >
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
  </section>

  <div class="flex items-center gap-2 mb-4 border-b border-gray-200 dark:border-gray-700">
    <button
      type="button"
      (click)="selectTab('powerbi')"
      [ngClass]="activeTab() === 'powerbi'
        ? 'border-sky-500 text-sky-600 dark:text-sky-400'
        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
      class="px-4 py-2 -mb-px text-sm font-semibold border-b-2 transition-colors"
    >
      Power BI
    </button>
    <button
      type="button"
      (click)="selectTab('excel')"
      [ngClass]="activeTab() === 'excel'
        ? 'border-sky-500 text-sky-600 dark:text-sky-400'
        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
      class="px-4 py-2 -mb-px text-sm font-semibold border-b-2 transition-colors"
    >
      Excel
    </button>
    <button
      type="button"
      (click)="selectTab('api')"
      [ngClass]="activeTab() === 'api'
        ? 'border-sky-500 text-sky-600 dark:text-sky-400'
        : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'"
      class="px-4 py-2 -mb-px text-sm font-semibold border-b-2 transition-colors"
    >
      API
    </button>
  </div>

  <div class="relative mb-4">
    <input type="text" [value]="displayedUrl()" readonly class="w-full bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-gray-700 dark:text-gray-300">
    <button (click)="copyUrl()" class="absolute inset-y-0 right-0 px-4 py-2 bg-blue-500 text-white rounded-r-md hover:bg-blue-600">
      Copiar
    </button>
  </div>

  <ng-container *ngIf="activeTab() === 'powerbi'">
    <section class="grid grid-cols-2 gap-x-4">
      <div class="grid-cols-1">
        <p class="text-sm text-gray-700 dark:text-gray-300 mb-2">
          Para usar esta API en Power BI debes crear dos parámetros:
          <br />
          - <b class="text-sky-600 dark:text-sky-500 font-bold">Url</b>: Asigna el valor del campo de arriba.
          <br />
          - <b class="text-sky-600 dark:text-sky-500 font-bold">Token</b>: Obtén el token desde el ERP TSI.
        </p>
      </div>
      <div class="grid-cols-1 flex flex-row space-y-4">
        <span class="text-sm text-gray-700 dark:text-gray-300 mb-2"
          >Selecciona el formato:</span
        >
        <label
          class="inline-flex items-center mr-6 text-gray-900 dark:text-white"
        >
          <input
            type="radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            name="format"
            value="parquet"
            [(ngModel)]="selectedFormat"
            (change)="updatePowerBiScript()"
          />
          <span class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Parquet</span>
        </label>
        <label class="inline-flex items-center text-gray-900 dark:text-white">
          <input
            type="radio"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            name="format"
            value="csv"
            [(ngModel)]="selectedFormat"
            (change)="updatePowerBiScript()"
          />
          <span class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">CSV</span>
        </label>
      </div>
    </section>

    <div class="mt-4">
      <pre
        class="bg-gray-100 dark:bg-gray-900 rounded-md p-3 text-sm text-gray-800 dark:text-gray-200 overflow-x-auto"
      ><code>{{ powerBiScript }}</code></pre>
    </div>
  </ng-container>

  <ng-container *ngIf="activeTab() === 'excel'">
    <div class="text-sm text-gray-700 dark:text-gray-300 space-y-3">
      <p>
        Excel no soporta el formato <b>Parquet</b>, por lo que el enlace de
        arriba ya incluye <b class="text-sky-600 dark:text-sky-500">?format=csv</b>.
        Sigue estos pasos para importar el reporte:
      </p>

      <ol class="list-decimal pl-5 space-y-2">
        <li>
          En Excel, ve a <b>Datos → Obtener datos → De otras fuentes → Desde la Web</b>.
        </li>
        <li>
          Selecciona la opción <b>Avanzada</b>.
        </li>
        <li>
          En el campo <b>URL</b>, pega el enlace de arriba.
        </li>
        <li>
          En <b>Encabezados HTTP</b>, agrega un encabezado:
          <div class="mt-1 ml-2 grid grid-cols-[8rem,1fr] gap-x-3 gap-y-1 text-xs">
            <span class="font-semibold text-gray-900 dark:text-gray-100">Nombre</span>
            <code class="bg-gray-100 dark:bg-gray-900 rounded px-2 py-0.5">Authorization</code>
            <span class="font-semibold text-gray-900 dark:text-gray-100">Valor</span>
            <code class="bg-gray-100 dark:bg-gray-900 rounded px-2 py-0.5">Bearer &lt;TU_TOKEN&gt;</code>
          </div>
        </li>
        <li>
          Pulsa <b>Aceptar</b>. Si Excel solicita credenciales, elige
          <b>Anónimo</b> y luego <b>Cargar</b> los datos.
        </li>
      </ol>
    </div>
  </ng-container>

  <ng-container *ngIf="activeTab() === 'api'">
    <div class="text-sm text-gray-700 dark:text-gray-300 space-y-3">
      <p>
        Consume el reporte como <b class="text-sky-600 dark:text-sky-500">JSON</b>
        desde cualquier lenguaje o cliente HTTP. Incluí el token en el encabezado
        <code class="bg-gray-100 dark:bg-gray-900 rounded px-2 py-0.5">Authorization: Bearer &lt;TU_TOKEN&gt;</code>.
        Usá <b>Generar Bearer</b> para copiar el encabezado completo, o
        <b>Generar Token</b> para obtener solo el token. Vigencia: 30 días.
      </p>
    </div>

    <div class="mt-5">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
          Raw <span class="text-gray-500 dark:text-gray-400 font-normal">— arreglo plano de registros</span>
        </h3>
        <span class="text-xs px-2 py-0.5 rounded bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-300 font-medium">
          Ideal para scripts / pipelines
        </span>
      </div>
      <p class="text-xs text-gray-600 dark:text-gray-400 mb-2">
        El enlace de arriba ya incluye <b class="text-sky-600 dark:text-sky-500">?format=json</b>.
        Respuesta: <code class="bg-gray-100 dark:bg-gray-900 rounded px-1.5 py-0.5">[ &#123;...&#125;, &#123;...&#125; ]</code>
      </p>
      <pre
        class="bg-gray-100 dark:bg-gray-900 rounded-md p-3 text-sm text-gray-800 dark:text-gray-200 overflow-x-auto"
      ><code>{{ apiCurl() }}</code></pre>
    </div>

    <div class="mt-5">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
          Wrapped <span class="text-gray-500 dark:text-gray-400 font-normal">— envoltura estándar TSI</span>
        </h3>
        <span class="text-xs px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300 font-medium">
          Ideal para clientes web
        </span>
      </div>
      <div class="relative mb-2">
        <input type="text" [value]="apiDataUrl()" readonly
          class="w-full bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 text-gray-700 dark:text-gray-300 text-sm">
        <button (click)="copyDataUrl()"
          class="absolute inset-y-0 right-0 px-4 py-2 bg-blue-500 text-white rounded-r-md hover:bg-blue-600 text-sm">
          Copiar
        </button>
      </div>
      <p class="text-xs text-gray-600 dark:text-gray-400 mb-2">
        Misma data envuelta en <code class="bg-gray-100 dark:bg-gray-900 rounded px-1.5 py-0.5">&#123; status, message, object, list &#125;</code>
        para que el cliente pueda validar <code class="bg-gray-100 dark:bg-gray-900 rounded px-1.5 py-0.5">status === 1</code> antes de consumir.
        El servidor concatena el archivo por bytes — memoria acotada, mismo costo que el raw.
      </p>
      <pre
        class="bg-gray-100 dark:bg-gray-900 rounded-md p-3 text-sm text-gray-800 dark:text-gray-200 overflow-x-auto"
      ><code>{{ apiDataCurl() }}</code></pre>
    </div>
  </ng-container>

  <div class="grid grid-cols-3 gap-3 mt-6">
    <button
      (click)="onClose()"
      class="bg-gray-500 text-white rounded-md py-2 hover:bg-gray-600"
    >
      Cerrar
    </button>
    <button
      type="button"
      (click)="generateToken()"
      [disabled]="generating()"
      class="bg-sky-600 text-white rounded-md py-2 hover:bg-sky-700 disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ generating() ? 'Generando…' : 'Generar Token' }}
    </button>
    <button
      type="button"
      (click)="generateBearer()"
      [disabled]="generating()"
      class="bg-sky-700 text-white rounded-md py-2 hover:bg-sky-800 disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ generating() ? 'Generando…' : 'Generar Bearer' }}
    </button>
  </div>
</div>
